import { useMutation } from 'react-query';
import {PartnerApi} from "../../api/partner.api";
import {useVendorsStore} from "../../store/vendors.store";

export const useVendor = () => {
    const setVendor = useVendorsStore((state) => state.setVendor);

    return useMutation(PartnerApi.vendor, {
        onSuccess: (data) => {
            setVendor(data);
        },
        onError: (error) => {
            console.error('Login failed:', error);
        },
    });
};